import React from 'react';
import { inject, observer } from 'mobx-react';
import { Segment } from 'semantic-ui-react';
import 'styling/semantic.less';
import Navbar from '../components/Navbar/Navbar';
import { Route, withRouter } from 'react-router';
import Manager from 'routes/Manager';
import User from 'routes/User';
import Admin from 'routes/Admin';
import Viewer from 'routes/Viewer';
import Auth from 'stores/Auth';
import { Redirect, Switch } from 'react-router-dom';
import RootStore from 'stores/RootStore';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { observable } from 'mobx/lib/mobx';
import { logRocketId } from '../constants';
import Reminder from '../stores/Reminder';
import { toJS } from 'mobx';
const INACTIVY_LOGOUT_TIMER = 30 * 60 * 1000; //30 minutes
const logLogRocket = window?.location.hostname === 'staging-app.scriptmanager.com.au';
if (logLogRocket) {
	LogRocket.init(logRocketId);
	setupLogRocketReact(LogRocket);
}

@withRouter
@inject(root => ({
	auth: root.auth,
	uiShared: root.uiShared,
	root: root
}))
@observer
export default class MainApp extends React.Component {
	props: {
		auth?: Auth,
		history: History,
		root?: RootStore
	};
	@observable logRocketInitialized: boolean = false;
	@observable showReminders: boolean = false;

	componentDidMount = async () => {
		// this.idleTimer(this.props.auth); //idle logout disabled
		const { auth } = this.props;
		const user = auth.user;
		if (logLogRocket) {
			if (user && !this.logRocketInitialized) {
				LogRocket.identify(
					`[${window.location.hostname}] ${user.id} ${user?.firstName} ${user?.lastName}`,
					{
						name: user.username,
						userId: user.id
					}
				);
				this.logRocketInitialized = true;
			}
		}

		if (window.addEventListener) {
			window.addEventListener('storage', this.sessionStorage_handler, true);
		} else {
			window.attachEvent('onstorage', this.sessionStorage_handler);
		}

		const practiceHasReminder = await Reminder.hasReminderEnabledPractice(user.id);
		this.showReminders = practiceHasReminder && user.scheduledReminders;
	};

	sessionStorage_handler = event => {
		if (!event) {
			event = window.event;
		}
		if (!event.newValue) return;
		if (sessionStorage.length && event.key == 'removeSessionStorage') {
			this.props.auth.logOutTab();
		}
	};

	idleTimer = auth => {
		let t;
		window.onmousemove = resetTimer; // catches mouse movements
		window.onmousedown = resetTimer; // catches mouse movements
		window.onclick = resetTimer; // catches mouse clicks
		window.onscroll = resetTimer; // catches scrolling
		window.onkeypress = resetTimer; //catches keyboard actions

		function logout() {
			this.props.uiShared.showSpinner('Logging out...');
			auth.logOut();
		}

		function resetTimer() {
			clearTimeout(t);
			t = setTimeout(logout, INACTIVY_LOGOUT_TIMER);
		}
	};

	createNavItem(content, path, rest = {}) {
		const { history, location } = this.props;
		const { refreshFn, ...props } = rest;
		return {
			as: 'a',
			href: 'javascript:void(0)',
			content: content,
			onClick: () => {
				if (refreshFn) {
					refreshFn();
				}
				history.push(path);
			},
			key: content,
			active: location.pathname.endsWith(path),
			...props
		};
	}

	render() {
		const { href } = window.location;
		if (href.indexOf('/authCode?') > -1) {
			return (
				<Segment loading={true}>
					<div />
				</Segment>
			);
		}

		const { auth, match, root, uiShared } = this.props;
		const role = auth.user.role;
		let leftMenuItems = [];
		let logOut = {
			as: 'a',
			href: 'javascript:void(0)',
			content: 'Logout',
			onClick: () => {
				let msg = role == 'admin' ? 'Logging-out...' : 'Logging-out from PRODA...';
				uiShared.showSpinner(msg);
				auth.logOut();
				uiShared.hideModal();
			},
			icon: 'sign out',
			key: 'sign-out'
		};
		let goToProfile = this.createNavItem('Profile', `/app/${role}/profile`, {
			icon: 'user'
		});
		let terms = this.createNavItem('Terms and Condition', `/app/${role}/terms`, {
			icon: 'file alternate outline'
		});
		let privacy = this.createNavItem('Privacy Policy', `/app/${role}/privacy`, {
			icon: 'lock'
		});
		let contact = this.createNavItem('Contact Us', `/app/${role}/contact`, {
			icon: 'mail outline'
		});
		let rightMenuItems = [];

		switch (role) {
			case 'manager':
				leftMenuItems = [this.createNavItem('Dashboard', '/app/manager')];
				rightMenuItems = [goToProfile, terms, privacy, contact, logOut];
				break;
			case 'admin':
				leftMenuItems = [
					this.createNavItem('Users', '/app/admin'),
					this.createNavItem('Practices', '/app/admin/practices'),
					this.createNavItem('Prescribers', '/app/admin/prescribers'),
					this.createNavItem('Reminders', '/app/admin/reminders')
				];
				rightMenuItems = [goToProfile, logOut];
				break;
			case 'user':
				leftMenuItems = [this.createNavItem('Dashboard', '/app/user')];
				rightMenuItems = [goToProfile, terms, privacy, contact, logOut];
				break;
			case 'viewer':
				leftMenuItems = [this.createNavItem('Dashboard', '/app/viewer')];
				rightMenuItems = [goToProfile, terms, privacy, contact, logOut];
				break;
		}

		if (role !== 'admin' && this.showReminders) {
			leftMenuItems.push(this.createNavItem('Reminders', `/app/${role}/reminders`));
		}

		return (
			<Navbar rightItems={rightMenuItems} leftItems={leftMenuItems}>
				<Switch>
					<Route path={`${match.url}/manager`} component={Manager} />
					<Route path={`${match.url}/user`} component={User} />
					<Route path={`${match.url}/admin`} component={Admin} />
					<Route path={`${match.url}/viewer`} component={Viewer} />
					<Redirect to={`${match.url}/${role}`} />
				</Switch>
			</Navbar>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/MainApp.js